import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '../../../auth/auth.service';
import { ToastService } from '../../../_core/services/toast.service';
import { finalize, Subject, takeUntil } from 'rxjs';
import { TeamDetailsService } from '../../../my-teams/team-details/team-details.service';
import { Team } from '../../../_shared/models/team.model';

@Component({
  selector: 'app-follow-team',
  templateUrl: './follow-team.component.html',
  styleUrls: ['./follow-team.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FollowTeamComponent implements OnDestroy {
    private authService = inject(AuthService);
    private teamDetailsService = inject(TeamDetailsService);
    private toast = inject(ToastService);
    private cdr = inject(ChangeDetectorRef);

    @Input({ required: true }) _teamId: string;
    @Input({ required: true }) teamViewers: string[] = [];
    @Input({ required: false }) tieId: string;
    isLoadingFollow: boolean;
    private destroyed$: Subject<void> = new Subject();
    team: Team;

    async ngOnInit(){
        await this.getTeamInfo();
    }

    async getTeamInfo(){
        this.team = await this.teamDetailsService.info(this._teamId);
    }

    ngOnDestroy() {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

    isViewer(): boolean {
        return this.teamViewers?.includes(this.authService.authUserSignal()?._id)
    }

    unfollow() {
        this.isLoadingFollow = true;

        this.teamDetailsService
        .unfollow(this._teamId, this.tieId)
        .pipe(
          finalize(() => {
            this.isLoadingFollow = false;
            this.cdr.detectChanges();
        }),
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (res) => {
            this.teamViewers = this.teamViewers?.filter(viewer => viewer !== this.authService.authUserSignal()._id);
          },
        });
    }

    async follow() {
        this.isLoadingFollow = true;

        this.teamDetailsService
        .follow(this._teamId, this.tieId)
        .pipe(
          finalize(() => {
            this.isLoadingFollow = false;
            this.cdr.detectChanges();
        }),
          takeUntil(this.destroyed$)
        )
        .subscribe({
          next: (res) => {
            if (!this.teamViewers) this.teamViewers = [];
            this.teamViewers.push(this.authService.authUserSignal()._id);
          },
        });
    }

}
